import { AnyAction } from 'redux';
import {
  BACK_IN_STOCK_SET_PERSONAL_DATA_PAGE_POINTER,
  BACK_IN_STOCK_STATE_CHANGED,
} from '../constants';

export interface BackInStockModalState {
  showBackInStockModal: boolean;
  productArticleNumber: string;
  size?: string;
  personalDataPagePointer?: string;
}

const DEFAULT_STATE: BackInStockModalState = {
  showBackInStockModal: false,
  productArticleNumber: '',
  size: '',
  personalDataPagePointer: '',
};

export const backInStockModal = (
  state = DEFAULT_STATE,
  action: AnyAction
): BackInStockModalState => {
  switch (action.type) {
    case BACK_IN_STOCK_STATE_CHANGED:
      return {
        ...state,
        showBackInStockModal: action.payload.modalOpen,
        productArticleNumber:
          action.payload.productArticleNumber ??
          state.productArticleNumber,
        size: action.payload.size,
      };
    case BACK_IN_STOCK_SET_PERSONAL_DATA_PAGE_POINTER:
      return {
        ...state,
        personalDataPagePointer: action.payload,
      };
    default:
      return state;
  }
};
